module.exports = __webpack_public_path__ + "media/images/soar/advantages_cartoon-b4b8d507e0f4a9dbc56bb512b7703a4d.png";